export default __webpack_public_path__ + "static/media/IMG_2001.ce21eaf9.JPG";